import type { RecipeProposal } from './recipeProposal';
import type { ExpenseDraft } from './receipts';
import type { CatalogPricesProposal } from './catalogPrices';
import type { PurchaseDocumentType } from './types';
import type { Unit } from './units';
import type { ExpenseInput } from './validation';

export type DraftSource = 'whatsapp' | 'email' | 'app' | 'demo';
export type DraftStatus = 'pending' | 'confirmed' | 'discarded' | 'expired';
export interface AnswerProposal { kind: 'confirm-price'; ingredientId: string; unitPrice: number; unit: Unit; questionId: string }
export interface DraftBase {
  id: string;
  tenantId: string;
  locationId?: string;
  source: DraftSource;
  createdBy: { userSub?: string; phone?: string; email?: string };
  status: DraftStatus;
  inputKey?: string;
  summary: string;
  createdAt: string;
  expiresAt: number;
  confirmedAt?: string;
  lastCorrectionId?: string;
  result?: { recipeId?: string; expenseId?: string; ingredientIds?: string[] };
}
export type Draft = DraftBase & (
  | { kind: 'expense'; payload: { proposal: ExpenseDraft; input?: ExpenseInput; documentType?: PurchaseDocumentType; requiresReview?: boolean } }
  | { kind: 'recipe'; payload: RecipeProposal }
  | { kind: 'catalog-prices'; payload: CatalogPricesProposal }
  | { kind: 'answer'; payload: AnswerProposal }
);

export const DRAFT_TTL_SECONDS = 7 * 24 * 60 * 60;
export function draftIsExpired(draft: Pick<DraftBase, 'expiresAt' | 'status'>, now = Date.now()): boolean {
  return draft.status === 'expired' || draft.expiresAt <= Math.floor(now / 1000);
}
export function draftDomainPath(kind: Draft['kind']): string {
  return kind === 'expense' ? '/v1/expenses' : kind === 'recipe' ? '/v1/recipes/proposal/confirm' : '/v1/import/ingredients';
}

/** Conversación privada de cada miembro; los borradores mantienen su confirmación habitual. */
export interface InboxInput { id: string; text: string; fileName?: string; draftIds?: string[]; replyToDraftId?: string }
export interface InboxEntry extends InboxInput {
  createdAt: string;
  expiresAt: number;
  reply?: string;
  cards: Array<{ draft: Draft; text: string }>;
}
